// import React, { Component } from 'react';

// class Timer extends Component {
//   constructor(props) {
//     super(props);
//     this.state = {
//       seconds: 60,
//     };
//   }

//   componentDidMount() {
//     this.interval = setInterval(this.tick, 1000);
//   }

//   componentWillUnmount() {
//     clearInterval(this.interval);
//   }

//   tick = () => {
//     this.setState((prevState) => {
//       if (prevState.seconds > 0) {
//         return { seconds: prevState.seconds - 1 };
//       } else {
//         clearInterval(this.interval); // Stop the timer when it reaches 60 seconds
//         return { seconds: 0 };
//       }
//     });
//   };

//   render() {
//     const { seconds } = this.state;
//     return (
//       <div>
//         <h1>0: {seconds}</h1>
//       </div>
//     );
//   }
// }

// export default Timer;


import React, { useEffect, useState } from 'react';

const Timer = ({setShowResendButton, showResendButton}) => {
  const [seconds, setSeconds] = useState(60);

  useEffect(() => {
    const interval = setInterval(() => {
      if (seconds > 0) {
        setSeconds((prevSeconds) => prevSeconds - 1);
      } else {
        clearInterval(interval); // Stop the timer when it reaches 60 seconds
      }
    }, 1000);

    if (seconds > 0) {
      setShowResendButton(false)
    } else {
      setShowResendButton(true)
    }

    return () => {
      clearInterval(interval); // Cleanup the interval on unmount
    };
  }, [seconds, showResendButton]);

  useEffect(() => {
    if (!showResendButton) {
       setSeconds(60)
    }
   
  }, [showResendButton])




  return (
    <div>
      <h1>0: {seconds}</h1>
    </div>
  );
};

export default Timer;
